module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_border-22c8c002daec224a669207f5c0a0e407.png";